"use strict";
/*
 * /download — refreshes the server-rendered release card from
 * GET /api/v1/desktop-releases/latest. The HTML may come from a shared cache,
 * so the live numbers win; SSR stays as the no-JS/crawler fallback.
 *
 * Only textContent / attribute writes — no HTML injection (CSP + XSS).
 */
(function () {
  var card = document.getElementById("download-card");
  if (!card || typeof window.fetch !== "function") {
    return;
  }

  var latestUrl = card.getAttribute("data-latest-url") || "/api/v1/desktop-releases/latest";
  var sizeTemplate = card.getAttribute("data-size-template") || "{size} MB";
  var lang = (document.documentElement.getAttribute("lang") || "ru").toLowerCase();
  var dateLocale = lang === "kz" || lang === "kk" ? "kk-KZ" : "ru-RU";

  function setText(name, value) {
    var nodes = card.ownerDocument.querySelectorAll('[data-release="' + name + '"]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.tagName === "A") {
        return;
      }
      node.textContent = value;
    });
  }

  function setLink(name, href) {
    var nodes = card.ownerDocument.querySelectorAll('a[data-release="' + name + '"]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (href && /^https:\/\//.test(href)) {
        node.setAttribute("href", href);
        node.hidden = false;
      } else if (name === "offline_installer_url") {
        node.hidden = true;
      }
    });
  }

  function formatSize(bytes) {
    var mb = Math.round((bytes / 1048576) * 10) / 10;
    return sizeTemplate.replace("{size}", String(mb));
  }

  function formatDate(iso) {
    var date = new Date(iso);
    if (isNaN(date.getTime())) {
      return iso.slice(0, 10);
    }
    try {
      return date.toLocaleDateString(dateLocale, { year: "numeric", month: "long", day: "numeric" });
    } catch (e) {
      return iso.slice(0, 10);
    }
  }

  function apply(release) {
    if (!release || typeof release.version !== "string") {
      return;
    }
    setText("version", release.version);
    setText("channel", release.channel || "stable");
    if (typeof release.size === "number") {
      setText("size", formatSize(release.size));
    }
    if (typeof release.released_at === "string") {
      setText("released_at", formatDate(release.released_at));
      var time = card.querySelector('time[data-release="released_at"]');
      if (time) {
        time.setAttribute("datetime", release.released_at);
      }
    }
    if (typeof release.sha256 === "string") {
      setText("sha256", release.sha256);
    }
    if (typeof release.notes === "string" && release.notes.trim()) {
      setText("notes", release.notes);
    }
    setLink("installer_url", release.installer_url);
    setLink("offline_installer_url", release.offline_installer_url);
    if (release.changelog_url) {
      setLink("changelog_url", release.changelog_url);
    }

    var ready = card.querySelector(".download-card-ready");
    var pending = card.querySelector(".download-card-pending");
    if (ready) {
      ready.hidden = false;
    }
    if (pending) {
      pending.hidden = true;
    }
    card.setAttribute("data-state", "ready");
  }

  // SSR already rendered a date in ISO form; localise it even if the fetch fails.
  var ssrTime = card.querySelector('time[data-release="released_at"]');
  if (ssrTime && ssrTime.getAttribute("datetime")) {
    ssrTime.textContent = formatDate(ssrTime.getAttribute("datetime"));
  }

  fetch(latestUrl, { headers: { Accept: "application/json" }, credentials: "omit" })
    .then(function (response) {
      if (!response.ok) {
        return null;
      }
      return response.json();
    })
    .then(apply)
    .catch(function () {
      /* keep the server-rendered card */
    });
})();
